import { services } from '@/axios/http'

const fetch = ({ url = '/get_fights' }) =>
  services(url)
    .get()
    .then(response => response.data)

export default fetch
